export default {
  Title: 'Special Stain',
  DateCreateFrom: 'Date Created From',
  DateCreateTo: 'To',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  SpecialStainStatus: 'Special Stain Status',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  Sex: 'Sex',
  Status: 'Status',
  Select: 'Select',
  Block: 'Block',
  Slide: 'Slide',
  Find: 'Find',
  Add: 'Add',
  SentDate: 'Sent Date',
  SentTo: 'Sent To',
  Remark: 'Remark',
  BlockNo: 'Block No',
  SlideNo: 'Slide No',
  Qty: 'Slide Quantity',
  PrintSlide: 'Print Slide',
  HN: 'HN',
  Export: 'Export',
  SlidePrepare: 'Slide Preparation',
  Staining: 'Staining'
}
